import React from "react";
import "./style.scss";
import Icon from "../icons";


const Popup = (props) => {
    return (
        <div className="popup-container p-30 d-flex justify-content-center align-items-center ">
            <div className="popup-content-block relative">
                {props.close &&
                    <div onClick={props.close} className="popup-close absolute top-20 right-20">
                        <Icon name="close" />
                    </div> 
                }
                <div className="scrollbar-popup scrollbar">
                    {props.children}
                </div>
            </div>
        </div>
    );
}
export default Popup;